
import React, { useState, useEffect } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Label,
    CardHeader,
    FormGroup,
    Input,
} from "reactstrap";
import { breadcrumbReturnFunc, btnIsDissablefunc, } from "../../../components/Common/CommonFunction";
import { useDispatch, useSelector } from "react-redux";

import { MetaTags } from "react-meta-tags";
import { mode, pageId, url } from "../../../routes";
import { Breadcrumb_inputName, commonPageField, commonPageFieldSuccess } from "../../../store/actions";
import { comAddPageFieldFunc, formValChange, formValid, initialFiledFunc, } from "../../../components/Common/validationFunction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import * as _cfunc from "../../../components/Common/CommonFunction";
import { C_Select, C_TimePicker } from "../../../CustomValidateForm";
import { allLabelWithZero } from "../../../components/Common/CommonErrorMsg/HarderCodeData";
import { SaveButton } from "../../../components/Common/CommonButton";
import { editGenericMessageSuccess, saveGenericMessage, saveGenericMessageSuccess, updateGenericMessage, updateGenericMessageSuccess } from "../../../store/Administrator/GenericMessageRedux/action";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import SaveButtonDraggable from "../../../components/Common/saveButtonDraggable";
import { getRole } from "../../../store/Administrator/RoleMasterRedux/action";
import RichTextEditor from "../../../components/Common/RichEditor";


const GenericMessageMaster = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();

    // ----------------------
    // Initial Field Config
    // ----------------------
    const fileds = {
        MessageText: "",
        IsActive: true,
        IsPOS: false,
        Party: "",
        ValidFrom: _cfunc.getDateTime_dmy(0),
        ValidTo: _cfunc.getDateTime_dmy(0),
        // ValidFrom: new Date(),   //  CURRENT DATE
        // ValidTo: new Date(),     //  CURRENT DATE
    };

    // ----------------------
    // Local States
    // ----------------------
    const [pageMode, setPageMode] = useState(mode.defaultsave);
    const [state, setState] = useState(() => initialFiledFunc(fileds));
    const [userPageAccessState, setUserAccState] = useState("");
    const [modalCss, setModalCss] = useState(false);
    const [editCreatedBy, seteditCreatedBy] = useState("");
    const [RoleDropdown, setRoleDropdown] = useState([]);





    // ----------------------
    // Redux State
    // ----------------------
    const {
        Party,
        partyDropdownLoading,
        postMsg,
        pageField,
        userAccess,
        saveBtnloading,
        RoleList
    } = useSelector((state) => ({
        saveBtnloading: state.GenericMessageReducer.saveBtnloading,
        postMsg: state.GenericMessageReducer.PostData,
        updateMsg: state.GenericMessageReducer.updateMessage,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
        Party: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
        partyDropdownLoading: state.CommonPartyDropdownReducer.partyDropdownLoading,
        RoleList: state.RoleMaster_Reducer.roleList
    }));


    // ----------------------
    // Page Field Load
    // ----------------------
    useEffect(() => {
        const page_Id = pageId.GENERIC_MESSAGE_MASTER;
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id));
    }, [dispatch]);

    useEffect(() => {
        dispatch(getRole());
    }, [dispatch]);

    // ----------------------
    // Derived Values
    // ----------------------
    const values = { ...state.values };
    const { isError } = state;
    const { fieldLabel } = state;

    const location = { ...history.location };
    const hasShowModal = props.hasOwnProperty(mode.editValue);
    const [PartyDropdown, setPartyDropdown] = useState([allLabelWithZero]);

    // ----------------------
    // User Access & Breadcrumb
    // ----------------------
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;


        if (hasShowModal) {
            locationPath = props.masterPath;
        }

        userAcc = userAccess.find(
            (inx) => `/${inx.ActualPagePath}` === locationPath
        );

        if (userAcc) {
            setUserAccState(userAcc);
            breadcrumbReturnFunc({ dispatch, userAcc });
        }
    }, [userAccess]);

    // ----------------------
    // Dynamic Page Fields
    // ----------------------
    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster;
            comAddPageFieldFunc({ state, setState, fieldArr });
        }
    }, [pageField]);

    // ----------------------
    // SAVE Success Effect
    // ----------------------
    useEffect(() => {

        //  SUCCESS (200)
        if (postMsg?.Status === true && postMsg?.StatusCode === 200) {

            dispatch(saveGenericMessageSuccess({ Status: false }));

            customAlert({
                Type: 1,           // success
                Status: true,
                Message: postMsg.Message,
            }).then(() => {
                history.push({
                    pathname: url.GENERIC_MESSAGE_LIST,
                });
            });
        }

        //  ERROR (400 / Status false)
        else if (postMsg?.Status === false && postMsg?.StatusCode === 400) {

            dispatch(saveGenericMessageSuccess({ Status: false }));

            customAlert({
                Type: 3,           // error
                Message: postMsg.Message,
                // "Message already exists for the given time period."
            });
        }

    }, [postMsg]);



    function convertToDMY_HMS(input) {
        if (!input) return "";

        const date = input instanceof Date ? input : new Date(input);
        if (isNaN(date.getTime())) return "";

        const pad = (n) => String(n).padStart(2, "0");

        return (
            pad(date.getDate()) +
            "-" +
            pad(date.getMonth() + 1) +
            "-" +
            date.getFullYear() +
            " " +
            pad(date.getHours()) +
            ":" +
            pad(date.getMinutes()) +
            ":" +
            pad(date.getSeconds())
        );
    }

    useEffect(() => {

        if (pageMode === mode.edit && Party?.length > 0 && values.Party !== undefined && values.Party !== null) {

            // ✅ Case 1: ALL
            if (values.Party === 0 || values.Party === "0") {
                setPartyDropdown([allLabelWithZero]);
            }

            // ✅ Case 2: multiple OR single
            else {

                const partyIds = String(values.Party)   // 🔥 FORCE STRING
                    .split(",")
                    .map(Number);

                const selectedParties = Party
                    .filter(p => partyIds.includes(p.id))
                    .map(p => ({
                        value: p.id,
                        label: p.Name
                    }));

                setPartyDropdown(selectedParties);
            }
        }

    }, [Party, pageMode, values.Party]);

    useEffect(() => {
        if (pageMode === mode.edit && RoleList?.length > 0 && values.Role) {

            const roleIds = values.Role.split(",").map(Number);

            const selectedRoles = RoleList
                .filter(r => roleIds.includes(r.id))
                .map(r => ({
                    value: r.id,
                    label: r.Name
                }));

            setRoleDropdown(selectedRoles);
        }
    }, [RoleList]);



    useEffect(() => {

        let hasEditVal = null;

        if (location?.editValue) {
            setPageMode(location.pageMode || mode.edit);
            hasEditVal = location.editValue;
        }
        else if (props?.editValue) {
            setPageMode(props.pageMode || mode.edit);
            hasEditVal = props.editValue;
            setModalCss(true);
        }

        if (hasEditVal && Party?.length > 0) {

            const {
                id,
                MessageText,
                IsActive,
                IsPOS,
                ValidFrom,
                ValidTo,
                Party: PartyId,
                Role: RoleId
            } = hasEditVal;

            const { values, fieldLabel, hasValid, required, isError } = { ...state };

            hasValid.MessageText.valid = true;
            values.id = id;
            values.MessageText = MessageText;
            values.IsActive = IsActive;
            values.IsPOS = IsPOS;
            values.Party = PartyId;
            values.Role = RoleId;
            //  DATE FIX (dd-mm-yyyy HH:mm:ss)
            values.ValidFrom = convertToDMY_HMS(ValidFrom);
            values.ValidTo = convertToDMY_HMS(ValidTo);

            setState({ values, fieldLabel, hasValid, required, isError });
            dispatch(Breadcrumb_inputName(MessageText));
        }

    }, [location?.editValue, props?.editValue, Party, RoleList]);


    // --------------Save Handler----------------

    const SaveHandler = async (event) => {

        event.preventDefault();
        const btnId = event.target.id;

        try {
            if (formValid(state, setState)) {


                btnIsDissablefunc({ btnId, state: true });

                const jsonBody = JSON.stringify({
                    MessageText: values.MessageText,
                    Role: RoleDropdown.map(r => r.value).join(","),


                    ValidFrom: _cfunc.convertDateTime_ydm(values.ValidFrom),
                    ValidTo: _cfunc.convertDateTime_ydm(values.ValidTo),

                    CompanyID: _cfunc.loginCompanyID(),
                    Party: PartyDropdown.some(p => p.value === 0) ? null : PartyDropdown.map(p => p.value).join(","),
                    IsActive: values.IsActive,
                    IsPOS: values.IsPOS
                });



                if (pageMode === mode.edit) {

                    dispatch(updateGenericMessage({
                        jsonBody,
                        updateId: values.id,
                        btnId,
                    }));
                } else {
                    dispatch(saveGenericMessage({
                        jsonBody,
                        btnId,
                    }));
                }
            }
        } catch (e) {
            btnIsDissablefunc({ btnId, state: false });
        }
    };


    // ----------------------
    // Handlers
    // ----------------------
    const onChangeText = ({ event, state, setState }) => {
        formValChange({ event, state, setState });
    };

    function PartyDrodownOnChange(selected) {

        if (!selected || selected.length === 0) {
            setPartyDropdown([]);
            return;
        }

        const lastSelected = selected[selected.length - 1];

        if (lastSelected.value === 0) {
            // 👉 User clicked ALL → remove others
            setPartyDropdown([allLabelWithZero]);
        } else {
            // 👉 User clicked normal option → remove ALL if present
            const filtered = selected.filter(s => s.value !== 0);
            setPartyDropdown(filtered);
        }
    }

    const Party_Option = [
        allLabelWithZero,   //  All option first
        ...Party.map((i) => ({
            value: i.id,
            label: i.Name,
            PartyType: i.PartyType,
        })),
    ];

    const Role_Options = Array.isArray(RoleList)

        ? RoleList.map((r) => ({
            value: r.id,
            label: r.Name
        }))
        : [];





    if (!(userPageAccessState === '')) {
        return (
            <React.Fragment>
                <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>
                <div className={"page-content"} >

                    <Container fluid>
                        <Row>
                            <Col lg={12}>
                                <Card className="text-black" >
                                    <CardHeader className="card-header   text-black c_card_header" >
                                        <h4 className="card-title text-black ">{userPageAccessState.PageDescription}</h4>
                                        <p className="card-title-desc text-black rich-content" dangerouslySetInnerHTML={{ __html: userPageAccessState.PageDescriptionDetails }} />
                                    </CardHeader>

                                    <CardBody className="mb-3">
                                        <form noValidate>
                                            <Card >
                                                <CardBody className="c_card_body ">
                                                    <Row className="align-items-end p-2">
                                                        <Row className="m-2">
                                                            {/* Valid From */}
                                                            <Col sm="3">
                                                                <FormGroup>
                                                                    <Label>{fieldLabel.ValidFrom}</Label>
                                                                    <C_TimePicker
                                                                        id="fromdate"
                                                                        value={values.ValidFrom}
                                                                        placeholder="Select From Date"
                                                                        data-enable-time
                                                                        data-enable-seconds
                                                                        data-enable-input

                                                                        options={{
                                                                            altInput: true,
                                                                            altFormat: "d-m-Y H:i:S",
                                                                            dateFormat: "d-m-Y H:i:S",
                                                                            minDate: pageMode === mode.edit ? null : "today",

                                                                        }}
                                                                        onChange={(obj, selectedDate) =>
                                                                            setState((prev) => ({
                                                                                ...prev,
                                                                                values: {
                                                                                    ...prev.values,
                                                                                    ValidFrom: selectedDate,
                                                                                },
                                                                            }))
                                                                        }
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            {/* Valid To */}
                                                            <Col sm="3">
                                                                <FormGroup>
                                                                    <Label>{fieldLabel.ValidTo}</Label>
                                                                    <C_TimePicker
                                                                        id="todate"
                                                                        value={values.ValidTo}
                                                                        placeholder="Select To Date"
                                                                        data-enable-time
                                                                        data-enable-seconds
                                                                        data-enable-input

                                                                        options={{
                                                                            altInput: true,
                                                                            altFormat: "d-m-Y H:i:S",
                                                                            dateFormat: "d-m-Y H:i:S",
                                                                            minDate: values.ValidFrom || "today",

                                                                        }}
                                                                        onChange={(obj, selectedDate) =>
                                                                            setState((prev) => ({
                                                                                ...prev,
                                                                                values: {
                                                                                    ...prev.values,
                                                                                    ValidTo: selectedDate,
                                                                                },
                                                                            }))
                                                                        }
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row className="m-2">
                                                            {/* Party */}
                                                            <Col sm="3">
                                                                <FormGroup>
                                                                    <Label>{fieldLabel.Party}</Label>
                                                                    <C_Select
                                                                        name="Party"
                                                                        value={PartyDropdown}
                                                                        isSearchable
                                                                        isMulti
                                                                        isLoading={partyDropdownLoading}
                                                                        className="react-dropdown"
                                                                        classNamePrefix="dropdown"
                                                                        options={Party_Option}
                                                                        onChange={PartyDrodownOnChange}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col sm="3">
                                                                <FormGroup>
                                                                    <Label>Role</Label>
                                                                    <C_Select
                                                                        name="Role"
                                                                        value={RoleDropdown}
                                                                        isSearchable
                                                                        isMulti
                                                                        className="react-dropdown"
                                                                        classNamePrefix="dropdown"
                                                                        options={Role_Options}
                                                                        onChange={(e) => setRoleDropdown(e)}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>

                                                        <Row className="align-items-center p-2 m-2">

                                                            {/* Message Text */}
                                                            <Col sm="6">
                                                                <FormGroup className="mb-2">
                                                                    <RichTextEditor
                                                                        label={fieldLabel.MessageText}
                                                                        value={values.MessageText}
                                                                        error={isError.MessageText}
                                                                        validate={{
                                                                            required: {
                                                                                value: false,
                                                                                errorMessage: "Please Enter MessageText"
                                                                            }
                                                                        }}
                                                                        onChange={(value) => {

                                                                            // ✅ direct state update (NO formValChange)
                                                                            setState((prev) => ({
                                                                                ...prev,
                                                                                values: {
                                                                                    ...prev.values,
                                                                                    MessageText: value
                                                                                }
                                                                            }));
                                                                            const plainText = value.replace(/<[^>]+>/g, "");
                                                                            dispatch(Breadcrumb_inputName(plainText));
                                                                        }}
                                                                    />
                                                                    {isError.MessageText.length > 0 && (
                                                                        <small className="text-danger">{isError.MessageText}</small>
                                                                    )}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row className="m-2">
                                                            {/* IsActive */}
                                                            <Col sm="3" className="d-flex align-items-center mt-2">
                                                                <Label className="me-2 mb-0">{fieldLabel.IsActive}</Label>
                                                                <div className="form-check form-switch form-switch-md ms-5">
                                                                    <Input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={values.IsActive}
                                                                        onChange={(e) =>
                                                                            setState((prev) => ({
                                                                                ...prev,
                                                                                values: {
                                                                                    ...prev.values,
                                                                                    IsActive: e.target.checked,
                                                                                },
                                                                            }))
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>

                                                            {/* IsPOS */}
                                                            <Col sm="3" className="d-flex align-items-center mt-2 ">
                                                                <Label className="me-2 mb-0">{fieldLabel.IsPOS}</Label>
                                                                <div className="form-check form-switch form-switch-md ms-5">
                                                                    <Input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={values.IsPOS}
                                                                        onChange={(e) =>
                                                                            setState((prev) => ({
                                                                                ...prev,
                                                                                values: {
                                                                                    ...prev.values,
                                                                                    IsPOS: e.target.checked,
                                                                                },
                                                                            }))
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>


                                                    </Row>
                                                </CardBody>
                                            </Card>


                                            <FormGroup className="mt-2">

                                                <SaveButton
                                                    loading={saveBtnloading}
                                                    onClick={SaveHandler}
                                                    pageMode={pageMode}
                                                    userAcc={userPageAccessState}
                                                    editCreatedBy={editCreatedBy}
                                                    module={"GENERIC_MESSAGE_MASTER"}
                                                />

                                            </FormGroup >
                                        </form>
                                    </CardBody>
                                </Card>
                            </Col >

                        </Row >


                    </Container >
                </div >
            </React.Fragment >
        );
    }
    else {
        return (
            <React.Fragment></React.Fragment>
        )
    }
}



export default GenericMessageMaster
